import { Link, type RouteObject } from 'react-router'
import { RequireViewer } from './components/RequireViewer'
import { Notice } from './components/ui'
import { WritingsIndex } from './pages/WritingsIndex'
import { SignInPage } from './pages/SignInPage'
import { ComposerPage } from './pages/ComposerPage'
import { PreviewPage } from './pages/PreviewPage'
import { ReaderPage } from './pages/ReaderPage'

function RouteError() {
  return (
    <Notice
      title="Something went wrong"
      body="This page hit an error. Your writing autosaves, so reloading is safe."
      action={<Link to="/">Back to Writings</Link>}
    />
  )
}

export const routes: RouteObject[] = [
  {
    errorElement: <RouteError />,
    children: [
      { path: '/', element: <RequireViewer><WritingsIndex /></RequireViewer> },
      { path: '/signin', element: <SignInPage /> },
      { path: '/w/:id', element: <RequireViewer><ComposerPage /></RequireViewer> },
      { path: '/w/:id/preview', element: <RequireViewer><PreviewPage /></RequireViewer> },
      // Public reader: burrow.world/<handle>/<slug>
      { path: '/:handle/:slug', element: <ReaderPage /> },
      { path: '*', element: <Notice title="Nothing here" action={<Link to="/">Back to Writings</Link>} /> },
    ],
  },
]
